<template>
  <div v-if="domain === 'agent' && pageType === 'bookable'" class="new-share-modal">
    <p class="mb-10 black fw-700 fs-16 lh-1">Copy Link</p>
    <div class="share-field flex justify-between mb-20">
      <input type="text" readonly :value="urlCopyLink" class="wp-100 py-12 px-30 pl-16 h-48 bg-white bd-1 bd-gray-medium ellipsis" >
      <button class="button button-primary" @click="shareCopyLink"> Copy </button>
    </div>
  </div>
  <ul v-else >
    <li class="mb-10">
      <button class="flex items-center" @click="shareFacebook">
        <img
          :src="`${$assetsCdn}/icons/facebook.svg`"
          width="24"
          height="24"
        />
        <span class="ml-10 black fs-14 lh-18">Facebook</span>
      </button>
    </li>
    <li class="mb-10">
      <button class="flex items-center" @click="shareTwitter">
        <img
          :src="`${$assetsCdn}/icons/twitter.svg`"
          width="24"
          height="24"
        />
        <span class="ml-10 black fs-14 lh-18">Twitter</span>
      </button>
    </li>
    <li>
      <button
        class="flex items-center"
        @click="shareCopyLink"
        h="copy-trip-plan-link"
      >
        <img
          :src="`${$assetsCdn}/icons/link.svg`"
          width="24"
          height="24"
        />
        <span class="ml-10 black fs-14 lh-18">{{ copyLinkText }}</span>
      </button>
    </li>
  </ul>
</template>
<script>
import { ref, computed, watch } from 'vue'
import { useRoute } from 'vue-router'
import { publicDomain } from '~/helper'
import { debounceHeapTracking } from '~/mixins/heap'
import { debounceAmplitudeScriptTracking } from '~/mixins/amplitude'
import { useTripPlanStore } from '~/store/pinia/tripPlan'
export default {
  name: 'ModalShare',
  props: {
    modalActive: {
      type: Boolean,
      default: false,
      required: true,
    },
    id: {
      type: [Number, String],
    },
    url: {
      type: String,
    },
    pageType: {
      type: String,
      default: 'gallery',
      validator: (value) =>
        ['gallery', 'bookable', 'preview'].includes(value.toLowerCase()),
    },
  },
  emits: ['update:modalActive', 'editTrip'],
  setup(props, { emit }) {
    const domain = publicDomain()
    const route = useRoute()
    const tripPlanStore = useTripPlanStore()
    
    const APP_FB_ID = useAppConfig().siteKeyFacebook || '486019852015123'
    const dataTrip = computed(() => tripPlanStore.dataTrip)
    const previewLink =
      domain === 'agent' || domain === 'agentpreview'
        ? useAppConfig().publicDomainAgentPreview
        : useAppConfig().publicDomainPreview
    const urlCopyLink = computed(() => {
      if (route.name === 'trip-plan' && domain === 'traveller') {
        return window.location.href
      } else {
        return `${previewLink}/${props.id}`
      }
    })
    const copyLinkText = ref('Copy Link')

    const modalShareActive = computed({
      get: () => props.modalActive,
      set: (value) => emit('update:modalActive', value),
    })

    watch(modalShareActive, (value) => {
      if (value === true) {
        copyLinkText.value = 'Copy Link'
      }
    })

    const heapTrackShare = (source) => {
      debounceHeapTracking('Share Trip Plan', {
        medium: source,
      }, 100)
      debounceAmplitudeScriptTracking('Share Trip Plan', {
        medium: source,
      }, 100)
    }

    const shareFacebook = () => {
      const facebookLink = `https://www.facebook.com/sharer/sharer.php?u=${urlCopyLink.value}`
      popupCenter(facebookLink, '')
      heapTrackShare('facebook')
      setTimeout(() => {
        modalShareActive.value = false
      }, 100)
    }
    const shareTwitter = () => {
      const twitterLink = `https://twitter.com/home?status=${urlCopyLink.value}`

      popupCenter(twitterLink, '')
      heapTrackShare('twitter')
      setTimeout(() => {
        modalShareActive.value = false
      }, 100)
    }
    const shareMessenger = () => {
      const messengerLink = `https://www.facebook.com/dialog/send?app_id=${APP_FB_ID}&link=${urlCopyLink.value}&redirect_uri=${urlCopyLink.value}`

      popupCenter(messengerLink, '')

      setTimeout(() => {
        modalShareActive.value = false
      }, 100)
    }
    const shareCopyLink = async () => {
      try {
        await navigator.clipboard.writeText(urlCopyLink.value)
        copyLinkText.value = 'Link Copied'
        setTimeout(() => {
          modalShareActive.value = false
        }, 800)
      } catch (e) {
        console.log(e)
      }
    }

    const openEditTrip = async () => {
      emit('editTrip')
      modalShareActive.value = false;
    }

    const popupCenter = (pageURL, title, w = 600, h = 400) => {
      let left = screen.width / 2 - w / 2
      let top = screen.height / 2 - h / 2
      window.open(
        pageURL,
        title,
        'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' +
          w +
          ', height=' +
          h +
          ', top=' +
          top +
          ', left=' +
          left,
      )
    }

    return {
      modalShareActive,
      copyLinkText,
      shareFacebook,
      shareTwitter,
      shareMessenger,
      shareCopyLink,
      domain,
      urlCopyLink,
      dataTrip,
      openEditTrip
    }
  },
}
</script>
<style lang="scss" scoped >
.new-share-modal {
  .share-field {
    input {
      border-radius: 6px 0 0 6px;
      @include focus-ring; // §14 — v2 §537 green focus ring (V12)
    }
  }

  button {
    border-radius: 0 6px 6px 0;
  }
}
</style>
